// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-info-indexstyleGrid-container-juucy{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-info-indexstyleGrid-grid-eanqa{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-info-indexstyleGrid-col6-byfqw{grid-column:span 6}.pages-info-indexstyleGrid-col3-cpvqc{grid-column:span 3}.pages-info-indexstyleGrid-col4-izqkt{grid-column:span 4}.pages-info-indexstyleGrid-col9-blsoi{grid-column:span 9}.pages-info-indexstyleGrid-col12-celqo{grid-column:span 12}.pages-info-indexstyleGrid-alignItemsStart-cequh{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-info-indexstyleGrid-container-juucy",
	"grid": "pages-info-indexstyleGrid-grid-eanqa",
	"col6": "pages-info-indexstyleGrid-col6-byfqw",
	"col3": "pages-info-indexstyleGrid-col3-cpvqc",
	"col4": "pages-info-indexstyleGrid-col4-izqkt",
	"col9": "pages-info-indexstyleGrid-col9-blsoi",
	"col12": "pages-info-indexstyleGrid-col12-celqo",
	"alignItemsStart": "pages-info-indexstyleGrid-alignItemsStart-cequh"
};
module.exports = ___CSS_LOADER_EXPORT___;
